import { useMutation } from "@tanstack/react-query";
import { ReferralProgramService } from "../../services/referral-program.service";

export const useReferralProgramSettingsMutations = () => {
  const { mutate: updateReferralSettings } = useMutation<
    any,
    Error,
    { id: string; model: { creditsReward: number } }
  >({
    mutationFn: async ({ id, model }) => ReferralProgramService.updateReferralSettings(id, model),
  });

  return {
    updateReferralSettings,
  };
};
